/** Данные дерева структуры с сервера (api/org-structure/tree) */
export interface OrgTreeData {
    companyName: string;
    units: OrgUnitData[];
    employees: OrgEmployeeData[];
    types: OrgUnitTypeData[];
    /** должности с рангами — для правки штата */
    positions: OrgPositionData[];
    organizations: { id: string; name: string }[];
    canEdit: boolean;
    canOpenEmployee: boolean;
    canEditEmployee: boolean;
}

export interface OrgUnitData {
    id: string;
    name: string;
    description: string;
    order: number | null;
    parentId: string | null;
    unitTypeId: string | null;
    managerId: string | null;
    /** служебный «Без отдела» — не удаляется */
    system: boolean;
    /** штатное расписание; пусто — штат не задан */
    staff: OrgStaffSlot[];
}

/** Строка штата: должность и число ставок. Занимают её действующие сотрудники подразделения с этой должностью */
export interface OrgStaffSlot {
    positionId: string;
    positionName: string;
    /** ранг только для подписи вакансии */
    gradeGuid: string | null;
    gradeName: string | null;
    count: number;
}

export interface OrgPositionData {
    id: string;
    name: string;
    grades: { guid: string; name: string }[];
}

export interface OrgEmployeeData {
    id: string;
    name: string;
    /** фото — отдельным запросом по api/org-structure/avatar/{id} */
    hasAvatar: boolean;
    departmentId: string;
    positionId: string | null;
    positionName: string | null;
    gradeName: string | null;
    nonProduction: boolean;
    poohBah: boolean;
    fired: boolean;
    fireDate: string | null;
    organizationId: string | null;
}

export interface OrgUnitTypeData {
    id: string;
    name: string;
    icon: string;
    order: number | null;
}

export interface OrgLogRecord {
    id: string;
    created: string;
    /** «дд.мм.гггг чч:мм» — даты API отдаёт без времени */
    createdAt: string;
    authorId: string | null;
    authorName: string;
    action: string;
    unitId: string | null;
    unitName: string | null;
    employerId: string | null;
    employerName: string | null;
    text: string;
    before: string | null;
    after: string | null;
}

export interface OrgChangeResult {
    warnings: string[];
}

/** Корень дерева — организация */
export const ROOT_ID = "__org";
